export const heroData = {
  tag: "每日更新 · 海量片库 · 免费高清",
  h1: "黄桃视频 · 免费高清影视在线观看平台",
  slogan: "好片不断档，精彩不等待",
  description: "黄桃视频致力于为影迷打造一站式免费观影体验，汇聚西瓜视频、芒果视频等主流平台海量影视内容。从热播电视剧到院线大片，从爆笑综艺到热血动漫，每日同步更新，全集流畅播放无缓冲。无论是追剧达人还是电影发烧友，在这里都能找到属于你的精彩世界。",
  stats: [
    { label: "覆盖剧集", value: "10万+" },
    { label: "每日更新", value: "200+集" },
    { label: "高清画质", value: "1080P" },
  ],
  primaryCta: { text: "立即观影", href: "#carousel" },
  secondaryCta: { text: "了解平台", href: "#about" },
  heroImage: "https://readdy.ai/api/search-image?query=Cinematic%20collage%20with%20film%20strips%2C%20movie%20clapperboard%2C%20popcorn%2C%20streaming%20device%20screen%20glowing%20in%20dark%2C%20warm%20amber%20and%20gold%20tones%2C%20entertainment%20atmosphere%2C%20soft%20dramatic%20lighting%2C%20modern%20home%20theater%20vibe%2C%20artistic%20composition%20with%20bokeh%20effects%2C%20cinematic%20color%20grading%2C%20cozy%20evening%20mood&width=1600&height=1200&seq=hero-visual-ht-01&orientation=landscape"
};

export const faqData = [
  {
    q: "黄桃视频需要注册才能观看吗？",
    a: "不需要注册，所有内容完全免费。打开网站即可直接观看西瓜视频、芒果视频等平台的海量电视剧、电影、综艺和动漫资源，无需任何账号或会员。"
  },
  {
    q: "视频画质怎么样？支持哪些清晰度？",
    a: "黄桃视频全站支持高清画质，主流内容提供1080P超清播放，画面细腻流畅。部分最新剧集还支持蓝光品质，配合智能缓冲技术，确保观看体验不打折。"
  },
  {
    q: "更新速度如何？最新剧集什么时候上线？",
    a: "我们与各大平台同步更新，热门电视剧和综艺通常在播出后2小时内上线。每日更新超过200集内容，涵盖国产剧、韩剧、美剧、日漫等多种类型，追剧不落空。"
  },
  {
    q: "手机上可以观看吗？有没有App？",
    a: "黄桃视频完美适配手机浏览器，无需下载App即可在移动端流畅观影。同时我们提供轻量级移动端入口，在微信内也能直接打开观看，随时随地享受追剧乐趣。"
  },
  {
    q: "黄桃视频和西瓜视频、芒果视频是什么关系？",
    a: "黄桃视频是独立的影视内容聚合平台，整合了西瓜视频、芒果视频等主流平台的优质内容资源，为用户提供一站式的免费观影入口。我们并非上述平台的分站或子品牌。"
  },
  {
    q: "播放卡顿怎么办？需要安装插件吗？",
    a: "完全不需要安装任何插件。如果遇到卡顿，建议检查网络连接或切换清晰度。黄桃视频采用多线路智能调度技术，自动选择最优播放节点，正常情况下都能流畅播放。"
  }
];

export const indexData = [
  {
    title: "热播剧集专区",
    desc: "《长相思》《莲花楼》《玉骨遥》等年度爆款一网打尽",
    icon: "ri-tv-2-line",
    color: "accent"
  },
  {
    title: "院线大片速递",
    desc: "最新上映的热门电影高清资源，足不出户看大片",
    icon: "ri-film-line",
    color: "primary"
  },
  {
    title: "综艺欢乐汇",
    desc: "《奔跑吧》《向往的生活》《这！就是街舞》精彩合集",
    icon: "ri-emotion-happy-line",
    color: "secondary"
  },
  {
    title: "热血动漫库",
    desc: "日漫、国漫、美漫全面覆盖，每周同步更新不等待",
    icon: "ri-rocket-line",
    color: "accent"
  },
  {
    title: "韩剧精选集",
    desc: "从经典老剧到最新热播，韩剧迷的追剧天堂",
    icon: "ri-heart-line",
    color: "primary"
  },
  {
    title: "纪录片天地",
    desc: "自然、历史、科技、美食纪录片，开阔你的视野",
    icon: "ri-global-line",
    color: "secondary"
  },
  {
    title: "少儿动画屋",
    desc: "益智启蒙、亲子共赏，给孩子一个绿色的观影空间",
    icon: "ri-parent-line",
    color: "accent"
  }
];

export const updatesData = [
  { time: "今天 14:30", text: "《长相思》第二季第28集更新上线，小夭身世之谜即将揭晓" },
  { time: "今天 12:00", text: "热门电影《封神第一部》高清版已入库，史诗级特效不容错过" },
  { time: "今天 09:15", text: "《奔跑吧·生态篇》最新一期上线，全员爆笑挑战极限任务" },
  { time: "昨天 20:00", text: "《咒术回战》第二季第18集同步更新，涉谷事变高潮迭起" },
  { time: "昨天 16:45", text: "韩剧《与恶魔有约》第10集更新，宋康金裕贞甜蜜对峙" },
  { time: "昨天 11:30", text: "纪录片《地球脉动3》全集上线，4K超清画质震撼呈现" },
  { time: "前天 18:20", text: "《莲花楼》全剧完结，成毅古装探案收官之作口碑爆棚" },
  { time: "前天 10:00", text: "《海贼王》第1080集更新，五档路飞激战凯多最终章" }
];

export const cardsData = [
  {
    title: "《长相思》第二季",
    desc: "杨紫、张晚意领衔主演，古装神话巨制持续热播中。小夭身世之谜、玱玹权谋之路，情感与权谋交织的史诗篇章。",
    tag: "热播榜首",
    tagColor: "accent",
    image: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20drama%20scene%20with%20flowing%20silk%20robes%2C%20traditional%20architecture%2C%20warm%20golden%20hour%20lighting%2C%20ethereal%20atmosphere%2C%20soft%20mist%2C%20cinematic%20composition%2C%20elegant%20oriental%20aesthetic%2C%20dreamy%20bokeh%20background&width=800&height=600&seq=card-img-ht-01&orientation=landscape"
  },
  {
    title: "《封神第一部》",
    desc: "乌尔善执导史诗巨制，费翔、李雪健主演。朝歌风云起，封神宇宙震撼开启，视觉特效达到国产电影新高度。",
    tag: "院线大片",
    tagColor: "primary",
    image: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20film%20scene%20with%20ancient%20warriors%20in%20ornate%20armor%2C%20dramatic%20sky%20with%20golden%20clouds%2C%20grand%20palace%20in%20distance%2C%20cinematic%20scale%2C%20heroic%20composition%2C%20warm%20firelight%20glow%2C%20misty%20battlefield&width=800&height=600&seq=card-img-ht-02&orientation=landscape"
  },
  {
    title: "《咒术回战》第二季",
    desc: "涉谷事变篇热血开战！五条悟封印、虎杖死斗，MAPPA顶级制作带来视觉盛宴，每一帧都是壁纸级别。",
    tag: "人气动漫",
    tagColor: "secondary",
    image: "https://readdy.ai/api/search-image?query=Anime%20style%20urban%20fantasy%20scene%20with%20dynamic%20action%20poses%2C%20glowing%20supernatural%20energy%20effects%2C%20modern%20Tokyo%20cityscape%20at%20night%2C%20dramatic%20lighting%2C%20vibrant%20color%20contrast%2C%20stylized%20Japanese%20animation%20aesthetic&width=800&height=600&seq=card-img-ht-03&orientation=landscape"
  },
  {
    title: "《与恶魔有约》",
    desc: "宋康、金裕贞主演韩剧热播中。冷血恶魔与财阀千金的契约婚姻，甜蜜与悬疑并存的浪漫喜剧。",
    tag: "韩剧精选",
    tagColor: "accent",
    image: "https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20scene%20with%20elegant%20couple%20in%20modern%20luxury%20setting%2C%20soft%20warm%20lighting%2C%20city%20night%20view%20through%20large%20windows%2C%20emotional%20atmosphere%2C%20cinematic%20depth%20of%20field%2C%20fashionable%20wardrobe&width=800&height=600&seq=card-img-ht-04&orientation=landscape"
  },
  {
    title: "《地球脉动3》",
    desc: "BBC史诗级自然纪录片回归！大卫·爱登堡旁白，4K超清拍摄全球珍稀动物，每一幕都是自然奇迹。",
    tag: "高分纪录",
    tagColor: "primary",
    image: "https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20wild%20animals%20in%20savanna%20sunset%2C%20golden%20hour%20light%20on%20grasslands%2C%20elephants%20silhouette%2C%20cinematic%20wide%20angle%2C%20breathtaking%20landscape%2C%20warm%20earthy%20tones%2C%20professional%20wildlife%20photography&width=800&height=600&seq=card-img-ht-05&orientation=landscape"
  }
];

export const topicsData = [
  { name: "#长相思第二季", heat: "182万讨论" },
  { name: "#封神第一部", heat: "156万讨论" },
  { name: "#咒术回战", heat: "143万讨论" },
  { name: "#韩剧推荐", heat: "128万讨论" },
  { name: "#综艺名场面", heat: "115万讨论" },
  { name: "#国产剧安利", heat: "98万讨论" },
  { name: "#动漫新番", heat: "87万讨论" },
  { name: "#高分电影", heat: "76万讨论" },
  { name: "#纪录片推荐", heat: "65万讨论" }
];

export const appData = {
  title: "随时随地 追剧无忧",
  desc: "黄桃视频完美适配手机、平板等移动设备，在浏览器中直接访问即可享受流畅观影体验。支持微信内直接打开，无需跳转App Store，更省空间更便捷。",
  features: ["免下载免安装", "微信直接打开", "流量消耗优化", "画质智能适配"],
  qrImage: "https://readdy.ai/api/search-image?query=Modern%20smartphone%20showing%20video%20streaming%20interface%20with%20movie%20posters%2C%20clean%20UI%20design%2C%20warm%20color%20scheme%2C%20held%20in%20hand%20against%20cozy%20home%20background%2C%20soft%20ambient%20lighting%2C%20lifestyle%20photography&width=600&height=600&seq=app-qr-ht-01&orientation=squarish"
};

export const contactData = {
  title: "联系与投稿",
  desc: "有好的影视资源想分享？发现内容问题需要反馈？欢迎通过以下方式联系黄桃视频团队。我们珍视每一位用户的建议，共同打造更好的免费观影平台。",
  email: "contact@huangtao.video",
  wechat: "黄桃视频官方",
  qq: "1234567890",
  tips: ["资源投稿请附带影片信息与来源", "内容反馈请提供具体剧集名称", "合作洽谈请备注合作意向"]
};

export const rankingData = [
  { rank: 1, title: "《长相思》第二季", tag: "电视剧", icon: "ri-fire-line", hot: "987万热度" },
  { rank: 2, title: "《封神第一部》", tag: "电影", icon: "ri-fire-line", hot: "876万热度" },
  { rank: 3, title: "《咒术回战》S2", tag: "动漫", icon: "ri-fire-line", hot: "765万热度" },
  { rank: 4, title: "《奔跑吧·生态篇》", tag: "综艺", icon: "ri-fire-line", hot: "654万热度" },
  { rank: 5, title: "《与恶魔有约》", tag: "韩剧", icon: "ri-fire-line", hot: "543万热度" },
  { rank: 6, title: "《莲花楼》", tag: "电视剧", icon: "ri-fire-line", hot: "432万热度" }
];

export const carouselData = [
  {
    title: "年度必看：国产奇幻巨制合集",
    desc: "从《长相思》到《莲花楼》，年度现象级国产剧一网打尽。古装、奇幻、探案多元题材，每一部都是口碑与热度双丰收的精品力作。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20drama%20collage%20with%20ancient%20temples%20and%20floating%20mountains%2C%20traditional%20Chinese%20aesthetic%2C%20warm%20golden%20and%20coral%20tones%2C%20ethereal%20clouds%2C%20cinematic%20composition%2C%20dreamy%20atmosphere%2C%20epic%20scale&width=1200&height=700&seq=carousel-ht-01&orientation=landscape"
  },
  {
    title: "韩剧控必追：2024热门韩剧速递",
    desc: "从悬疑烧脑到甜蜜爱情，精选全年最值得追的韩剧片单。宋康、金裕贞等顶级演员倾情演绎，每周同步更新不等待。",
    image: "https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%20with%20cherry%20blossoms%20and%20city%20backdrop%2C%20warm%20spring%20lighting%2C%20emotional%20couple%20moment%2C%20cinematic%20depth%2C%20soft%20pastel%20tones%2C%20elegant%20composition&width=1200&height=700&seq=carousel-ht-02&orientation=landscape"
  },
  {
    title: "热血动漫季：日漫新番一网打尽",
    desc: "咒术回战、海贼王、进击的巨人等超人气动漫全收录。国漫崛起之作同样不容错过，二次元世界尽在黄桃视频。",
    image: "https://readdy.ai/api/search-image?query=Anime%20action%20scene%20with%20dynamic%20characters%20and%20glowing%20energy%20effects%2C%20Japanese%20animation%20style%2C%20vibrant%20colors%2C%20dramatic%20composition%2C%20urban%20fantasy%20setting%2C%20cinematic%20lighting%2C%20intense%20atmosphere&width=1200&height=700&seq=carousel-ht-03&orientation=landscape"
  },
  {
    title: "综艺欢乐季：爆笑名场面合集",
    desc: "奔跑吧、向往的生活、这！就是街舞等王牌综艺全收录。轻松搞笑、竞技热血，承包你的下饭时光和周末娱乐。",
    image: "https://readdy.ai/api/search-image?query=Variety%20show%20studio%20set%20with%20colorful%20lights%20and%20cheerful%20atmosphere%2C%20group%20of%20people%20laughing%2C%20stage%20performance%20vibe%2C%20bright%20and%20vibrant%20colors%2C%20entertainment%20photography%2C%20dynamic%20composition&width=1200&height=700&seq=carousel-ht-04&orientation=landscape"
  },
  {
    title: "纪录天地：开阔视野的精品纪录",
    desc: "地球脉动、蓝色星球等BBC经典纪录片全系列入库。从自然奇观到历史人文，用镜头探索世界的每一个角落。",
    image: "https://readdy.ai/api/search-image?query=Nature%20documentary%20scene%20with%20aerial%20view%20of%20mountains%20and%20oceans%2C%20golden%20sunset%20light%2C%20breathtaking%20landscape%20photography%2C%20warm%20earthy%20tones%2C%20professional%20cinematography%2C%20vast%20scale%2C%20serene%20atmosphere&width=1200&height=700&seq=carousel-ht-05&orientation=landscape"
  }
];

export const mediaData = [
  {
    title: "《长相思》精彩幕后花絮",
    desc: "杨紫片场搞怪合集，玱玹小夭甜蜜互动NG花絮独家放送",
    duration: "06:28",
    image: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20set%20with%20actors%20in%20ancient%20Chinese%20costumes%20laughing%2C%20warm%20studio%20lighting%2C%20candid%20moment%2C%20professional%20film%20production%20environment%2C%20cinematic%20cameras%20in%20background&width=800&height=500&seq=media-ht-01&orientation=landscape"
  },
  {
    title: "《封神》视觉特效解析",
    desc: "乌尔善导演亲自讲解封神宇宙的特效制作幕后故事",
    duration: "12:45",
    image: "https://readdy.ai/api/search-image?query=Film%20visual%20effects%20studio%20with%20green%20screen%20and%20computer%20monitors%20showing%20CGI%20scenes%2C%20professional%20environment%2C%20warm%20ambient%20lighting%2C%20creative%20workspace%2C%20movie%20post-production%20aesthetic&width=800&height=500&seq=media-ht-02&orientation=landscape"
  },
  {
    title: "韩剧OST精选合集",
    desc: "年度最受欢迎韩剧原声带精选，《与恶魔有约》主题曲全收录",
    duration: "18:20",
    image: "https://readdy.ai/api/search-image?query=Music%20studio%20with%20warm%20mood%20lighting%2C%20headphones%20on%20wooden%20desk%2C%20sheet%20music%2C%20cozy%20atmosphere%2C%20Korean%20drama%20poster%20on%20wall%2C%20soft%20bokeh%2C%20artistic%20composition&width=800&height=500&seq=media-ht-03&orientation=landscape"
  },
  {
    title: "动漫声优访谈特辑",
    desc: "《咒术回战》主角声优独家专访，分享配音幕后心路历程",
    duration: "22:10",
    image: "https://readdy.ai/api/search-image?query=Voice%20recording%20studio%20with%20professional%20microphone%20and%20pop%20filter%2C%20dim%20warm%20lighting%2C%20anime%20posters%20on%20walls%2C%20soundproof%20panels%2C%20creative%20atmosphere%2C%20artistic%20depth%20of%20field&width=800&height=500&seq=media-ht-04&orientation=landscape"
  },
  {
    title: "综艺爆笑名场面盘点",
    desc: "《奔跑吧》本季最搞笑片段集锦，准备好笑出腹肌吧",
    duration: "09:55",
    image: "https://readdy.ai/api/search-image?query=Variety%20show%20game%20set%20with%20colorful%20obstacles%20and%20bright%20stage%20lights%2C%20cheerful%20atmosphere%2C%20people%20having%20fun%2C%20dynamic%20action%2C%20vibrant%20colors%2C%20entertainment%20photography&width=800&height=500&seq=media-ht-05&orientation=landscape"
  }
];

export const featuresData = [
  {
    title: "海量片库 每日更新",
    desc: "覆盖电视剧、电影、综艺、动漫、纪录片等全品类内容，每日同步更新最新剧集，追剧永不停步。",
    icon: "ri-database-2-line"
  },
  {
    title: "高清画质 流畅播放",
    desc: "全站支持1080P超清画质，智能缓冲技术确保播放流畅不卡顿，多线路自动切换保障观影体验。",
    icon: "ri-4k-line"
  },
  {
    title: "完全免费 无需注册",
    desc: "打开即看，无需注册登录。黄桃视频始终坚持免费理念，让每个人都能轻松享受优质影视内容。",
    icon: "ri-vip-crown-line"
  }
];

export const aboutData = {
  title: "关于黄桃视频",
  paragraphs: [
    "黄桃视频成立于2023年，是一个专注于提供免费高清影视内容的聚合平台。我们汇聚了西瓜视频、芒果视频等主流视频平台的优质资源，涵盖电视剧、电影、综艺、动漫、纪录片等多种内容类型，致力于为广大影迷打造一站式的观影体验。",
    "平台以\"好片不断档，精彩不等待\"为核心理念，每日同步更新超过200集内容，确保用户能够第一时间观看到最新剧集和热门影片。无论是国产剧爱好者、韩剧迷、动漫粉丝还是纪录片发烧友，都能在黄桃视频找到属于自己的内容天地。",
    "黄桃视频采用先进的智能调度与缓冲技术，全站支持1080P高清画质播放，在保证画质的同时优化流量消耗，让用户在手机、平板、电脑等各类设备上都能享受流畅的观影体验。我们始终坚持以用户体验为核心，持续优化产品功能与内容覆盖。"
  ]
};

export const commentsData = [
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20young%20Asian%20woman%20smiling%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20friendly%20expression%2C%20modern%20lifestyle%20portrait&width=200&height=200&seq=avatar-ht-01&orientation=squarish",
    name: "追剧小达人",
    time: "2天前",
    text: "真的爱死黄桃视频了！《长相思》更新速度和画质都超赞，再也不用到处找资源了，一个网站全搞定。推荐给所有追剧的小伙伴！",
    likes: 1286
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20young%20Asian%20man%20with%20confident%20smile%2C%20warm%20lighting%2C%20clean%20background%2C%20modern%20casual%20style&width=200&height=200&seq=avatar-ht-02&orientation=squarish",
    name: "电影发烧友阿杰",
    time: "3天前",
    text: "《封神第一部》高清版终于在这里看到了！画质完全不输影院，在家用投影仪看简直享受。纪录片资源也很全，赞！",
    likes: 965
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20Asian%20woman%20in%20her%20twenties%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20friendly%20vibe&width=200&height=200&seq=avatar-ht-03&orientation=squarish",
    name: "樱花落尽",
    time: "4天前",
    text: "韩剧迷的福音！《与恶魔有约》更新超及时，画质清晰流畅。终于不用翻墙找资源了，黄桃视频真的是良心平台。",
    likes: 842
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20Asian%20man%20in%20early%20thirties%20smiling%2C%20warm%20studio%20lighting%2C%20clean%20white%20background%2C%20approachable%20expression&width=200&height=200&seq=avatar-ht-04&orientation=squarish",
    name: "动漫二次元",
    time: "5天前",
    text: "《咒术回战》涉谷篇太燃了！更新速度和日本同步，画质还能选高清。国漫资源也越来越丰富了，强烈安利！",
    likes: 1563
  }
];

export const footerData = {
  slogan: "黄桃视频 — 好片不断档，精彩不等待",
  description: "黄桃视频汇聚西瓜视频、芒果视频等平台海量电视剧电影综艺动漫资源，免费高清在线观看，最新剧集全集不缓冲流畅播放。每日更新200+集内容，覆盖国产剧、韩剧、美剧、日漫、综艺、纪录片等全品类。无需注册，打开即看。",
  links: [
    { title: "内容分类", items: ["电视剧", "电影", "综艺", "动漫", "纪录片", "韩剧"] },
    { title: "热门推荐", items: ["热播榜单", "最新更新", "高分推荐", "专题合集", "话题讨论"] },
    { title: "平台信息", items: ["关于我们", "联系投稿", "移动端入口", "常见问答"] },
  ],
  partners: {
    title: "合作伙伴",
    items: []
  },
  copyright: "© 2024 黄桃视频 huangtao.video 版权所有"
};